import React, { useState } from "react";
import {
  Button,
  TextField,
  CircularProgress,
  Typography,
  Modal,
  Backdrop,
  Fade,
  Box,
} from "@mui/material";
// import Logo from "../../assets/logo.png";
import useStyles from "../../../globalStyles";
import { primaryColor } from "../../../constants/colors";
import AuthBackground from "../../../components/authBackground";
import { useNavigate } from "react-router-dom";
import "./style.css";
// import { send_code } from "../../../apis";
import axios from "axios";
import SnackbarAlert from "../../../components/snackbar/SnackbarAlert";

const ContactSupport = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  const [inputValues, setInputValues] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = () => {
    if (inputValues.name == "") {
      handleSnackbarVal(true, "error", `Name is required`);
    } else if (inputValues.email == "") {
      handleSnackbarVal(true, "error", `Email is required`);
    } else if (inputValues.message == "") {
      handleSnackbarVal(true, "error", `Message is required`);
    } else {
      setIsLoading(true);

      setTimeout(() => {
        handleSnackbarVal(
          true,
          "success",
          `Your message has been send to the contact support team`
        );
      }, 2000);

      setTimeout(() => {
        setIsLoading(false);
        handleCloseSnackbar();
        setInputValues({
          name: "",
          email: "",
          message: "",
        });
      }, 3000);
    }
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  return (
    <>
      <AuthBackground heading={"Zanny Support"}>
        <SnackbarAlert
          snackbarProps={snackbarProps}
          handleCloseSnackbar={handleCloseSnackbar}
        />
        <div className={classes.paper}>
          <Typography style={{ fontSize: "25px", fontWeight: "600" }}>
            Contact Support
          </Typography>
          <Typography style={{ fontSize: "16px", fontWeight: "400" }}>
            Send a message if you have any query, we will get back to you soon.
          </Typography>
          <TextField
            variant="outlined"
            margin="normal"
            required
            id="name"
            placeholder="Name"
            name="name"
            autoFocus
            className={classes.globalInput}
            onChange={handleChange}
            value={inputValues.name}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            id="email"
            placeholder="Email"
            name="email"
            autoComplete="email"
            className={classes.globalInput}
            onChange={handleChange}
            value={inputValues.email}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            id="message"
            placeholder="Message"
            name="message"
            multiline
            minRows={3}
            className={classes.globalInput}
            onChange={handleChange}
            value={inputValues.message}
          />

          <div style={{ textAlign: "center", width: "100%" }}>
            {isLoading ? (
              <CircularProgress style={{ color: primaryColor }} />
            ) : (
              <Button
                variant="contained"
                className={classes.loginBtn}
                size="small"
                onClick={handleLogin}
                disableRipple
              >
                <Typography className={classes.loginBtnText}>Send</Typography>
              </Button>
            )}
          </div>
        </div>
      </AuthBackground>
    </>
  );
};

export default ContactSupport;
